module.exports = __webpack_public_path__ + "static/media/Law.807dbf22.PNG";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/Law.PNG
// module id = 1765
// module chunks = 1